import { DataField } from '@sageworks/jpi';
import { CustomComponentType, TemplateDataField } from '../../../../../enums';
import { DataFieldConvertStrategy } from '../../data-field-convert-strategy';

export class RaceDataFieldConverter implements DataFieldConvertStrategy {
	private readonly allowedFields = new Set<number>([TemplateDataField.PersonalRace, TemplateDataField.OwnershipRace]);

	isFieldValid(dataField: DataField): boolean {
		return this.allowedFields.has(dataField.templateDataFieldId!);
	}

	convert(dataField: DataField, currentProperties: any) {
		const properties = { ...currentProperties };

		// Set as custom race multiselect field
		properties.type = CustomComponentType.raceMultiselectField;
		properties.multiple = true;
		properties.dataType = 'number';

		return properties;
	}
}
